import { BaseApiError } from '@/services/shared';

export type AppointmentStatus = string;

export interface AppointmentApi {
  id: string;
  patient_id: string;
  dietitian_id: string;
  scheduled_at: string;
  status: AppointmentStatus;
  type?: string | null;
  location?: string | null;
}

export interface PaginatedAppointmentsApi {
  items: AppointmentApi[];
  page: number;
  page_size: number;
  total_items: number;
}

export interface Appointment {
  id: string;
  patientId: string;
  dietitianId: string;
  scheduledAt: string;
  status: AppointmentStatus;
  type?: string | null;
  location?: string | null;
}

export interface PaginatedAppointments {
  items: Appointment[];
  page: number;
  pageSize: number;
  totalItems: number;
}

export interface AppointmentListRequest {
  dietitianId: string;
  patientId: string;
  page?: number;
  pageSize?: number;
}

export class AppointmentApiError extends BaseApiError {
  constructor(message: string, status?: number, fieldErrors?: Record<string, string>, code?: string) {
    super(message, status, fieldErrors, code);
    this.name = 'AppointmentApiError';
  }
}
